import Vue from 'vue';
import Vuex from 'vuex';
import {RawLocation} from "vue-router";
import {VueRouter} from "vue-router/types/router";
import {AxiosResponse} from "axios";
import {Token, User} from "@/models/service/Models";
import {Helper} from "@/plugins/helper";
import {ActionsEnum} from "@/entity/ActionsEnum";
import {fonts} from "@/entity/FontsEntity";
import App from "@/App.vue";
import {menuItems} from "@/store/menuItems";
import {PaymentTypeEntity} from "@/entity/PaymentTypeEntity";
import {ProductProperties} from "@/entity/ProductEntity";
import {city} from "@/entity/CityEntity";
import {district} from "@/entity/DistrictEntity";
import {OrderStatusEntity} from "@/entity/OrderStatusEntity";
import {CargoEntity} from "@/entity/CargoEntity";
Vue.use(Vuex);

export enum UserRole{
    UNKNOWN="unknown",
    GUEST="guest",
    VERIFIED_USER="verified-user",
    PENDING_USER="pending-user",
    LIMITED_ADMIN="limited-admin",
    ADMIN="admin",
}
class breadcrumb{
    text:String = "";
    disabled: boolean = false;
    href: string = "";
    link: boolean = false;
    to: string | object = {};
}
class snackbar {
    enabled:boolean = false;
    text:String = "";
}

class CacheData {
    fonts:fonts[] = [];
    paymentTypes:PaymentTypeEntity[] = [];
    productProperties:ProductProperties[] = [];
    cities:city[] = [];
    districts:district[] = [];
    orderStatus:OrderStatusEntity[] = [];
    cargo:CargoEntity[] = [];
}

export interface AppState {
    data:CacheData;
    token: Token | null;
    user:User |null;
    layoutName:String;
    breadcrumbItems:breadcrumb[];
    role:UserRole;
    pathname:string;
    initialTarget:RawLocation|null;
    router:VueRouter |null;
    helper:Helper
    imagePath:String;
    apiUrl:String;
    siteUrl:String;
    siteProxy:String;
    selectedMenuItem:any;
    menuItems:any;
    location:string;
    snackbar:snackbar;
}
let SITE_URL ="";
if(window.location.hostname =="localhost"){
    SITE_URL = "http://localhost:8095/";
}else{
    SITE_URL = "https://ekacocukaile.com/";
}


export const store = new Vuex.Store({
    state: {
        data: new CacheData(),
        snackbar:new snackbar(),
        token: null,
        user: null,
        imagePath:SITE_URL+"images/",
        apiUrl:SITE_URL+"admin/",
        siteUrl:SITE_URL,
        siteProxy:"/site/",
        location:window.location.href,
        pathname:window.location.pathname,
        initialTarget: null,
        layoutName:"GuestLayout",
        breadcrumbItems:[],
        router: null,
        helper: new Helper(),
        role:UserRole.UNKNOWN,
        selectedMenuItem:null,
        menuItems:menuItems
    },
    actions: {
        go(state,target){
            //console.log("target",target)
            if(target == null || target == undefined)
                return;
            this.dispatch("checkLayout");
            state.getters.router.push(target);
            this.state.initialTarget = target;
            //this.dispatch("breadcrumb");
        },
        goHome(state){
            //console.log("gohome");
            //this.dispatch("go",state.getters.home);
            this.dispatch("go",state.getters.home);
        },
        findAction(state){
            try{
                //if(state.getters.selectedMenuItem == null || 1 == 1){

                state.getters.menuItems.forEach((navs:any)=>{
                    navs.items.forEach((nav:any,key:number)=>{
                        //console.log(nav.route,state.getters.pathname);
                        if(state.getters.isLimitedAdmin) {
                            let permission = state.getters.user.permissions.find((x: any) => x.page == nav.action && x.get == "1"); //gosterme yetkisi varsa
                            //console.log("permission", permission);
                            if(!permission){
                                navs.items.splice(key,1);
                            }
                        }
                        if(nav.route == state.getters.pathname){
                            state.commit("setSelectedMenuItem",nav)
                            return;
                        }
                    })
                })

                //}
            }catch (e) {
                console.log(e);
            }
        },
        checkMenu(state){
          //state.getters.menuItems
        },
        navigate(state,item){
            this.commit("setSelectedMenuItem",item);
            this.dispatch("go",item.route);
        },
        login(state, user) {
            //console.log("login");
            //console.log("state",state);
            //console.log(user);
        },
        logout(state){
            localStorage.clear();
            state.commit("setUserAsGuest");
            state.dispatch("go","/login");
            //window.location.href = "/login";
            console.log("logout");
            //window.location.reload();
        },
        checkLayout(state){
            //console.log("checklayout");
            let GuestLayoutRoles = [UserRole.GUEST,UserRole.UNKNOWN,UserRole.PENDING_USER];
            let UserLayoutRoles  = [UserRole.ADMIN,UserRole.LIMITED_ADMIN];
            if(GuestLayoutRoles.find(role=>role == state.getters.userType)){
                state.commit("setLayoutName","GuestLayout");
            }
            if(UserLayoutRoles.find(role=>role == state.getters.userType)){
                state.commit("setLayoutName","UserLayout");
            }
            //console.log(state.getters.layoutName);
            this.dispatch("breadcrumb");
        },
        breadcrumb(state){
            state.commit("clearBreadcrumb");
            let routePath = "";
            state.getters.router.currentRoute.fullPath.split("/").forEach((path:string)=>{
                routePath += path;
                //console.log("path,",path)
                let bc = new breadcrumb();
                bc.href = routePath;
                bc.text = state.getters.helper.capitalize(path);
                //bc.to = state.getters.router.currentRoute.
                state.commit("pushBreadcrumb",bc);
            })
        },
        authInit(state) {
            //console.log("authInit");
            Vue.prototype.$http.get("login").then((response:AxiosResponse)=>{
                state.commit("setUser",response.data);
                //console.log("setUser",response.data);
                this.dispatch("checkLayout");
                this.dispatch("findAction");
                //console.log("rout",state.getters.router.currentRoute)
            }).catch((err:any)=>{
                //console.log(err);
                state.dispatch("logout");
            })
        },
        async getPaymentTypes(state){
            if(this.state.data.paymentTypes.length  > 0){
                return this.state.data.paymentTypes;
            }
           let response = await Vue.prototype.$http.get("paymentTypes");
           this.commit("setPaymentTypes",response.data);
           return response.data;
        },
        async getProductProperties(state){
            if(this.state.data.productProperties.length  > 0){
                return this.state.data.productProperties;
            }
            let response = await Vue.prototype.$http.get("productProperties");
            this.commit("setProductProperties",response.data);
            return response.data;
        },
        async getCountryCityDistrict(state){
            let response = await Vue.prototype.$http.get("countryCityDistrict");
            this.commit("setCountryCityDistrict",response.data);
        },
        async getCities(state){
            if(this.state.data.cities.length  > 0){
                return this.state.data.cities;
            }
            await this.dispatch("getCountryCityDistrict");
            return  this.state.data.cities;
        },
        async getDistricts(state){
            if(this.state.data.districts.length  > 0){
                return this.state.data.districts;
            }
            await this.dispatch("getCountryCityDistrict");
            return  this.state.data.districts;
        },
        async getOrderStatus(state){
            if(this.state.data.orderStatus.length  > 0){
                return this.state.data.orderStatus;
            }
            let response = await Vue.prototype.$http.get("orderStatus");
            this.commit("setOrderStatus",response.data);
            return response.data;
        },
        async getCargo(state){
            if(this.state.data.cargo.length  > 0){
                return this.state.data.cargo;
            }
            let response = await Vue.prototype.$http.get("cargo");
            this.commit("setCargo",response.data);
            return response.data;
        }
    },
    mutations: {
        clearBreadcrumb(state:AppState){
          state.breadcrumbItems = [];
        },
        setPaymentTypes(state:AppState,paymentTypes:any){
            state.data.paymentTypes  = paymentTypes;
        },
        setProductProperties(state:AppState,productProperties:any){
            state.data.productProperties  = productProperties;
        },
        setCountryCityDistrict(state:AppState,items:any){
          state.data.cities  = items.cities;
          state.data.districts  = items.districts;
        },
        setOrderStatus(state:AppState,items : any){
          state.data.orderStatus =  items;
        },
        setFonts(state:AppState,fonts:fonts[]){
            state.data.fonts = fonts;
        },setCargo(state:AppState,cargo:CargoEntity[]){
            state.data.cargo = cargo;
        },
        snackbar(state:AppState, text:string){
            state.snackbar.enabled = true;
            state.snackbar.text = text;
            setTimeout(()=>{
                state.snackbar.enabled = false
            },4000)
        },
        pushBreadcrumb(state:AppState,obj:breadcrumb){
          state.breadcrumbItems.push(obj);
        },
        setLayoutName(state:AppState, layoutName:String){
            state.layoutName = layoutName;
            //console.log("Layname set",layoutName);
        },
        setUserAsGuest(state:AppState){
            window.localStorage.clear();
            state.token=null;
            state.user=null;
            state.role = UserRole.GUEST;
        },
        setSelectedMenuItem(state:AppState,item:any){
            state.selectedMenuItem = item;
        },
        setInitialTarget(state:AppState, route:RawLocation) {
            console.log("setting initial target to vuex", route);
            state.initialTarget = route;
        },
        setRouter(state:AppState, router:VueRouter) {
            state.router = router;
        },
        setUser(state:AppState, user:User) {
            state.user = user;
            //console.log("roleee",state.user.role);
            switch (state.user.role) {
                case "guest":
                    state.role = UserRole.GUEST;
                    break;
                case "admin":
                    state.role = UserRole.ADMIN;
                    break;
                case "limited-admin":
                    state.role = UserRole.LIMITED_ADMIN;
                    break;
                case UserRole.PENDING_USER: 
                    state.role = UserRole.PENDING_USER;
                    break;
                case UserRole.VERIFIED_USER:
                    state.role = UserRole.VERIFIED_USER;
                    break;
                case "unknown":
                    state.role = UserRole.UNKNOWN;
                    break;
            }
            console.log("current role is set to ",state.role);
            console.log("state user",state.user);
        },
        setToken(state:AppState, token:Token) {
            state.token = token;
            localStorage.setItem("token",token.token);
        },
    },
    getters: {
        userType: (state:AppState) => {
            //console.log("getter worked here", state.role);
            return state.role;
        },
        user:(state:AppState) => state.user,
        pathname:(state:AppState) => state.pathname,
        selectedMenuItem:(state:AppState) => state.selectedMenuItem,
        menuItems:(state:AppState) => state.menuItems,
        apiUrl:(state:AppState) => state.apiUrl,
        siteUrl: (state:AppState) => state.siteUrl,
        siteProxy: (state:AppState) => state.siteProxy,
        imagePath:(state:AppState) => state.imagePath,
        helper: (state:AppState) => state.helper,
        router: (state:AppState) => state.router,
        initialTarget:(state:AppState) => state.initialTarget ,
        isLimitedAdmin:(state:AppState) => state.role == UserRole.LIMITED_ADMIN,
        isGuest:(state:AppState) => state.role == UserRole.GUEST,
        isUser:(state:AppState) => state.role == UserRole.VERIFIED_USER,
        isLoggedIn:(state:AppState) => state.role == UserRole.VERIFIED_USER || state.role == UserRole.ADMIN || state.role == UserRole.PENDING_USER,
        canLogout:(state:AppState) => state.role != UserRole.GUEST && state.role != UserRole.UNKNOWN,
        home: (state:AppState) => { return "/Anasayfa"
        },
    }
});
